import { CategoryDto } from "typing";
import { createStore } from "../adapter";

type CategoriesState = {
  selectedCategory: CategoryDto[] | null;
  categoryTitle: string;
  categoryUrl: string;
  thirdLevelCategory: CategoryDto[] | null;
  thirdLevelTitle: string;
  thirdLevelUrl: string;
};

type CategoriesDispatch = {
  setSelectedCategory: (category: CategoryDto[]) => void;
  setCategoryTitle: (title: string) => void;
  setCategoryUrl: (url: string) => void;
  setThirdLevelCategory: (category: CategoryDto[]) => void;
  setThirdLevelTitle: (title: string) => void;
  setThirdLevelUrl: (url: string) => void;
};

type CategoriesStore = CategoriesState & CategoriesDispatch;

export const useCategories = createStore<CategoriesStore>((set) => ({
  selectedCategory: null,
  categoryTitle: "",
  categoryUrl: "",
  setSelectedCategory: (category) => set({ selectedCategory: category }),
  setCategoryTitle: (title) => set({ categoryTitle: title }),
  setCategoryUrl: (url) => set({ categoryUrl: url }),
  setThirdLevelCategory: (category) => set({ thirdLevelCategory: category }),
  thirdLevelCategory: null,
  thirdLevelTitle: "",
  thirdLevelUrl: "",
  setThirdLevelTitle: (title) => set({ thirdLevelTitle: title }),
  setThirdLevelUrl: (url) => set({ thirdLevelUrl: url }),
}));
